import { ChangeEvent, FC } from 'react';

import { CampaignSource, CampaignSubSource } from 'utils/constants/campaign';

import { Cell, CellText, Checkbox } from '@hh.ru/magritte-ui';
import { ChevronDownOutlinedSize16, ChevronUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import styles from 'components/CpcFlexibleCreate/CpcForm/AdSources/SourceCheckbox/SourceCheckbox.module.less';

export interface SourceCheckboxProps {
    source: CampaignSubSource | CampaignSource;
    checked: boolean;
    indeterminate?: boolean;
    disabled: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    isNewSource?: boolean;
    dataQa: string;
    hasChildren?: boolean;
    expanded?: boolean;
    handleExpandableClick?: () => void;
}

const TrlKeys = {
    [CampaignSource.HH]: `campaign.info.sudo.actions.handTargetings.${CampaignSource.HH}`,
    // exp_PORTFOLIO-53635_start
    [CampaignSubSource.HHTopSearch]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.HHTopSearch}`,
    [CampaignSubSource.HHBanners]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.HHBanners}`,
    // exp_PORTFOLIO-53635_end
    [CampaignSubSource.Direct]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.Direct}`,
    [CampaignSource.Yandex]: `campaign.info.sudo.actions.handTargetings.${CampaignSource.Yandex}`,
    [CampaignSubSource.YandexSearch]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.YandexSearch}`,
    [CampaignSubSource.YandexNetwork]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.YandexNetwork}`,
    [CampaignSubSource.VK]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.VK}`,
    [CampaignSubSource.Social]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.Social}`,
    [CampaignSubSource.Adwords]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.Adwords}`,
    [CampaignSubSource.Facebook]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.Facebook}`,
    [CampaignSubSource.Instagram]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.Instagram}`,
    [CampaignSource.VKAds]: `campaign.info.sudo.actions.handTargetings.${CampaignSource.VKAds}`,
    [CampaignSubSource.VKAdsVK]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.VKAdsVK}`,
    [CampaignSubSource.VKAdsOK]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.VKAdsOK}`,
    [CampaignSubSource.VKAdsNetwork]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.VKAdsNetwork}`,
    [CampaignSubSource.VKAdsProject]: `campaign.info.sudo.actions.handTargetings.${CampaignSubSource.VKAdsProject}`,
};

export const SourceCheckbox: FC<SourceCheckboxProps> = ({
    source,
    checked,
    indeterminate,
    disabled,
    onChange,
    dataQa,
    hasChildren = false,
    expanded = false,
    handleExpandableClick,
}) => {
    const trl = useTrls();

    const ChevronIcon = expanded ? ChevronUpOutlinedSize16 : ChevronDownOutlinedSize16;

    return (
        <div className={styles.wrapper}>
            <Cell
                width="fit-content"
                left={
                    <Checkbox
                        value={source}
                        checked={checked}
                        indeterminate={indeterminate}
                        disabled={disabled}
                        onChange={onChange}
                        data-qa={dataQa}
                    />
                }
            >
                <CellText style={disabled ? 'secondary' : 'primary'}>{trl(TrlKeys[source])}</CellText>
            </Cell>
            {hasChildren && <ChevronIcon initialColor="secondary" onClick={handleExpandableClick} />}
        </div>
    );
};
